webpackJsonp([10991734084388],{

/***/ 914:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _semanticUiReact = __webpack_require__(19);
	
	__webpack_require__(914);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPage = function AboutPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'about-page' },
	      _react2.default.createElement(
	        _semanticUiReact.Container,
	        null,
	        _react2.default.createElement(
	          'h1',
	          { className: 'about-page__headline' },
	          'About Us'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'The 2018 PME-NA Local Organizing Committee is comprised of mathematics education faculty members from the University of South Carolina and Clemson University.  This year\u2019s conference is a collaborative endeavor of these institutions.'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Local Organizing Committee Co-Chairs'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Thomas Hodges, University of South Carolina'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'George Roy, University of South Carolina'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Andy Tyminski, Clemson University'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'The Steering Committee is the governing body of and is responsible for managing ',
	          _react2.default.createElement(
	            'a',
	            { href: 'http://www.pmena.org/', target: '_blank' },
	            'PME-NA'
	          ),
	          '. It is composed of both elected and appointed members. The Steering Committee is composed of nine members-at-large elected by the Membership, including at least one member from each of Canada, Mexico, and the United States. These members serve staggered three-year terms of office, with typically three elected each year. In addition, the Graduate Student Membership elects two graduate student members each year for a term of one year.'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Steering Committee Members'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'A list of steering committee members is available at this ',
	          _react2.default.createElement(
	            'a',
	            { href: 'http://www.pmena.org/steering-committee/', target: '_blank' },
	            'link'
	          ),
	          '.'
	        )
	      )
	    )
	  );
	};
	
	exports.default = AboutPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-index-js-0aaa920e85a098cbf66b.js